var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Alert, Button, Form, Input, Select } from 'antd';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { history } from 'src/App';
import form from 'src/shared/decorators/form';
import Page from 'src/shared/layout/Page';
import { Score } from 'src/shared/services/service-proxies';
import services from 'src/shared/services/services';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {};
        _this.loading = true;
        _this.creating = false;
        _this.save = function () {
            _this.props.form.validateFields(function (errors, values) {
                if (!errors) {
                    _this.loading = true;
                    services.Score.save(_this.model)
                        .then(function (c) { return (_this.loading = false); })
                        .catch(function () { return (_this.loading = false); });
                }
            });
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = this.props.match.params.id;
                        if (!(id === 'new')) return [3 /*break*/, 1];
                        this.model = Score.fromJS({ name: 'Yeni Kategori' });
                        this.creating = true;
                        return [3 /*break*/, 3];
                    case 1:
                        _a = this;
                        return [4 /*yield*/, services.Score.get(id)];
                    case 2:
                        _a.model = _b.sent();
                        _b.label = 3;
                    case 3:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.render = function () {
        var _this = this;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement(Page, { buttons: React.createElement("div", null,
                React.createElement(Button, { type: "danger", onClick: function () { return history.push('/common/score'); } }, "\u0130ptal"),
                React.createElement(Button, { loading: this.loading, type: "primary", onClick: this.save }, "Kaydet")), breadcrumbs: [{ link: '/common/score', text: 'Puanlama Kategorileri' }], loading: this.loading, title: 'Puanlama: ' + this.model.name },
            React.createElement("div", { className: "card-header" },
                React.createElement("h5", { className: "card-title" }, "Puanlama D\u00FCzenleme")),
            React.createElement("div", { className: "card-body" },
                React.createElement(Form, { className: "row" },
                    React.createElement(Form.Item, { className: "col-md-6", label: "Ad\u0131" }, getFieldDecorator('name', {
                        initialValue: this.model.name,
                        rules: [{ required: true, message: 'Alan zorunlu!' }]
                    })(React.createElement(Input, { onChange: function (c) { return (_this.model.name = c.target.value); } }))),
                    React.createElement(Form.Item, { className: "col-md-6", label: "A\u00E7\u0131klama" }, getFieldDecorator('description', {
                        initialValue: this.model.description
                    })(React.createElement(Input, { onChange: function (c) { return (_this.model.description = c.target.value); } }))),
                    React.createElement(Form.Item, { className: "col-md-2", label: "Katsay\u0131" }, getFieldDecorator('multiplier', {
                        initialValue: this.model.multiplier,
                        rules: [{ required: true, message: 'Alan zorunlu!' }]
                    })(React.createElement(Input, { type: "number", onChange: function (c) { return (_this.model.multiplier = Number(c.target.value)); } }))),
                    React.createElement(Form.Item, { className: "col-md-2", label: "S\u0131ra" }, getFieldDecorator('order', {
                        initialValue: this.model.order,
                        rules: [{ required: true, message: 'Alan zorunlu!' }]
                    })(React.createElement(Input, { type: "number", onChange: function (c) { return (_this.model.order = Number(c.target.value)); } }))),
                    React.createElement(Form.Item, { className: "col-md-2", label: "Durum" }, getFieldDecorator('isActive', {
                        initialValue: this.model.isActive ? 1 : 0,
                        rules: [{ required: true, message: 'Alan zorunlu!' }]
                    })(React.createElement(Select, { onChange: function (c) { return (_this.model.isActive = Boolean(c)); } },
                        React.createElement(Select.Option, { value: 1 }, "Aktif"),
                        React.createElement(Select.Option, { value: 0 }, "Pasif")))))),
            React.createElement("div", { className: "card-footer" },
                React.createElement(Alert, { style: { fontWeight: 'bold' }, message: "L\u00FCtfen katsay\u0131 de\u011Ferini 0-1 aras\u0131nda giriniz. \u00D6r: %30 i\u00E7in 0.3 veya %5 i\u00E7in 0.05", type: "info" }))));
    };
    __decorate([
        observable
    ], default_1.prototype, "model", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    __decorate([
        observable
    ], default_1.prototype, "creating", void 0);
    default_1 = __decorate([
        form,
        observer
    ], default_1);
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/app/common/score/Edit.tsx
// module id = 1274
// module chunks = 0